import type { ITableCell } from "../types";
import { extractCellText } from "./extract-cell-text";

const idMapCache = new WeakMap<ITableCell[], Map<string, ITableCell>>();

const cellsById = (tableData: ITableCell[]): Map<string, ITableCell> => {
  let byId = idMapCache.get(tableData);
  if (!byId) {
    byId = new Map();
    for (const c of tableData) if (c) byId.set(c.id, c);
    idMapCache.set(tableData, byId);
  }
  return byId;
};

export const makeCellResolver = (
  tableData: ITableCell[],
): {
  resolveCell: (cell: ITableCell | undefined) => ITableCell | undefined;
  resolveText: (cell: ITableCell | undefined) => string;
} => {
  const byId = cellsById(tableData);
  const resolveCell = (cell: ITableCell | undefined) =>
    cell?.mergedInto ? (byId.get(cell.mergedInto) ?? cell) : cell;
  const resolveText = (cell: ITableCell | undefined) => {
    const anchor = resolveCell(cell);
    return anchor ? extractCellText(anchor.content) : "";
  };
  return { resolveCell, resolveText };
};
